import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=60acb74e&"
import script from "./MailIcon.vue?vue&type=script&lang=js&"
export * from "./MailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports